import Component from './Form';

export default Component;
